import { useState, useEffect } from 'react';
import { searchGraphUsers, GraphUser } from '../../../utils/MsGraphApiCall';

/**
 * Custom hook for Microsoft Graph user search with debouncing
 */
export const useGraphUserSearch = () => {
  const [people, setPeople] = useState<GraphUser[]>([]);
  const [loadingPeople, setLoadingPeople] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState('');

  // Search Microsoft Graph for people
  const searchPeople = async (searchTerm: string) => {
    if (!searchTerm || searchTerm.length < 2) {
      setPeople([]);
      return;
    }

    setLoadingPeople(true);
    try {
      const results = await searchGraphUsers(searchTerm);
      setPeople(results);
    } catch (error) {
      console.error('Error searching people:', error);
      setPeople([]);
    } finally {
      setLoadingPeople(false);
    }
  };

  // Debounced search effect
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      searchPeople(searchInputValue);
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [searchInputValue]);

  const resetSearch = () => {
    setPeople([]);
    setSearchInputValue('');
  };

  return {
    people,
    loadingPeople,
    searchInputValue,
    setSearchInputValue,
    resetSearch
  };
};

export default useGraphUserSearch;